import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, tone = "gold" }) => (
  <p
    className={`font-mono text-[11px] md:text-xs uppercase tracking-[0.35em] ${
      tone === "gold" ? "text-gold" : "text-brand"
    }`}
  >
    {children}
  </p>
);
